var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    fill: "#a5a5a5",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100,0C44.9,0,0,44.9,0,100s44.9,100,100,100c55.1,0,100-44.9,100-100S155.1,0,100,0z M140.8,130.8c2.8,2.8,2.8,7.3,0,10.1 c-1.4,1.4-3.2,2.1-5,2.1c-1.8,0-3.7-0.7-5.1-2.1L100,110.1l-30.8,30.5c-1.4,1.4-3.2,2.1-5,2.1c-1.8,0-3.7-0.7-5.1-2.1 c-2.8-2.8-2.8-7.3,0.1-10.1L89.9,100L59.2,69.2c-2.8-2.8-2.8-7.3,0-10.1c2.8-2.8,7.3-2.8,10.1,0L100,89.9l30.8-30.5 c2.8-2.8,7.3-2.8,10.1,0.1c2.8,2.8,2.8,7.3-0.1,10.1L110.1,100L140.8,130.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose);
export default __webpack_public_path__ + "static/media/ico-close.e8308a9e3ed92bc48d84d81a91841712.svg";
export { ForwardRef as ReactComponent };